import { combineReducers } from "redux";
import { reducer as formReducer } from "redux-form";

import DashboardReducer from "./Dashboard.reducer";

import AppSettingReducer from "./AppSettings.reducer";
import AuthReducer from "./Auth.reducer";
import CommonReducer from "./Common.reducer";
import StateReducer from "./State.reducer";
import ProgramReducer from "./Program.reducer";
import ClientReducer from "./Client.reducer";
import ClientProgramsReducer from "./ClientPrograms.reducer";
import AppUsersReducer from "./AppUsers.reducer";
import PetReducer from "./Pet.reducer";
import HealthTipsReducer from "./HealthTips.reducer";
import QuizReducer from "./Quiz.reducer";
import DoctorReducer from "./Doctor.reducer";
import RewardReducer from "./Reward.reducer";
import GiftStoreReducer from "./GiftStore.reducer";
import ReportedSideEffectsReducer from "./ReportedSideEffects.reducer";
import RoleReducer from "./Role.reducer";
import AssociatedUsersReducer from "./AssociatedUsers.reducer";
import AdminUsersReducer from "./AdminUsers.reducer";
import UserQueriesReducer from "./UserQueries.reducer";
import UserformReducer from "./UserForm.reducer";
import ProgramformReducer from "./ProgramForm.reducer";
import DoctorformReducer from "./DoctorForm.reducer";
import DietReducer from "./Diet.reducer";
import AssociatedEmployeesReducer from "./AssociatedEmployees.reducer";
import ShiftsReducer from "./Shifts.reducer";
import VitalsformReducer from "./VitalsForm.reducer";

const rootReducer = combineReducers({
  state: (state = {}) => state,
  form: formReducer,
  app_setting: AppSettingReducer,
  dashboard: DashboardReducer,
  auth: AuthReducer,
  common: CommonReducer,
  state: StateReducer,
  program: ProgramReducer,
  client: ClientReducer,
  client_programs: ClientProgramsReducer,
  appusers: AppUsersReducer,
  pet: PetReducer,
  health: HealthTipsReducer,
  quiz:QuizReducer,
  doctor:DoctorReducer,
  reward:RewardReducer,
  gift: GiftStoreReducer,
  side_effects: ReportedSideEffectsReducer,
  role: RoleReducer,
  associatedUsers: AssociatedUsersReducer,
  admin: AdminUsersReducer,
  user_queries: UserQueriesReducer,
  user_form:UserformReducer,
  program_form:ProgramformReducer,
  doctor_form:DoctorformReducer,
  diet:DietReducer,
  Shifts:ShiftsReducer, 
  associatedEmployee:AssociatedEmployeesReducer,
  vitals_form:VitalsformReducer
});

export default rootReducer;
